// Copyright (c) 2023, Schweizer Alpen-Club. This file is part of
// hitobito and licensed under the Affero General Public License version 3
// or later. See the COPYING file at the top-level directory or at
// https://github.com/hitobito/hitobito

import { Application, Controller } from "@hotwired/stimulus"
import { registerGeneratedControllers } from "../generated/controllers"

const stimulus = Application.start()

registerGeneratedControllers(stimulus)

export { Application, Controller, stimulus }
